package com.essntl.features.proposal.ui.proposalhistory

import com.essntl.features.proposal.domain.model.ProposalModel

sealed interface ProposalOverviewEvent {
    data class GetProposal(val id: String) : ProposalOverviewEvent

    data class ShowProposalOverview(val proposal: ProposalModel) : ProposalOverviewEvent

    data class GetProposalHistory(
        val id: String,
        val proposalParentStatus: ProposalModel.Status?,
    ) : ProposalOverviewEvent

    data object ClearState : ProposalOverviewEvent
}